<template>
    <div class="footer-div">
      <span class="copyright">Copyright ©ELECTRONIC LIBRARY INCORPORATED All rights reserved</span>
    </div>
</template>

<script>
  export default {
      name: 'footers',
    data() {
      return {
       
      };
    },
    
  };
</script>

<style scoped>
@import "../../assets/css/style.css";
.footer-div .copyright {
  color: var(--grayDark2) !important;
  font-size: 6.4pt;
}
.el-container.footer-div.is-vertical {
  height: 20px;
  width: 90%;
  margin: 0 auto;
  margin-top: 50px;
}
.el-footer {
  text-align: left !important;
  padding: 0px !important;
}

.footer-div {
  margin: 0px auto;
}

</style>